import 'iframe-resizer/js/iframeResizer.contentWindow'
import 'url-polyfill'
import 'url-search-params-polyfill'

import { v4 as uuidv4 } from 'uuid'

import {
  getPolicyMetadata,
  selectLocale,
} from '@termly-web/common'

import getPolicyContent from './lib/getPolicyContent'
import getWebsiteUUID from './lib/getWebsiteUUID'
import postStatistics from './lib/postStatistics'
import postTranslatedPolicyEvent from './lib/postTranslatedPolicyEvent'


export default async function hostedPolicy({ policyUUID }) {
  const websiteUUID = await getWebsiteUUID({
    policyUUID,
  })

  const {
    data: {
      created_locales: supportedLocales,
      id: documentID,
      template_type: templateType,
      total_published_count: totalPublishedCount,
      uuid: documentUUID,
    },
  } = await getPolicyMetadata({
    policyUUID,
    websiteUUID,
  })

  if ( totalPublishedCount === 0 ) {
    throw new Error('No published policy was found')
  }

  const locale = selectLocale({
    supportedLocales,
    preferredLocales: window.navigator.languages,
  })

  try {
    postStatistics({
      policyUUID: documentUUID,
      websiteUUID,
    })
  } catch (error) {
    console.warn('Failed to post statistics: %o', error)
  }

  const content = await getPolicyContent({
    documentID,
    locale,
    policyUUID,
    websiteUUID,
  })

  const docDiv = document.createElement('div')
  docDiv.innerHTML = content

  // This is used by iframe-resizer to calculate the height of the <iframe> in which
  // this content will be displayed.
  docDiv.dataset.iframeHeight = true

  document.getElementById('hosted').appendChild(docDiv)

  // Cookie policies are already translated on the server side
  if ( templateType !== 'Cookie' ) {
    window.Weglot?.initialize({
      api_key: process.env.WEGLOT_API_KEY,
    })

    window.Weglot?.on('languageChanged', (newLang) => {
      if ( newLang === 'en' ) {
        return
      }

      // Doesn't need to be persisted—the backend just needs a unique string
      // to attach the event to.
      const identity = uuidv4()
      const params = new URLSearchParams(window.location.search)
      const viewMethod = params.get('viewMethod') || 'direct_url'

      try {
        postTranslatedPolicyEvent({
          identity,
          language: newLang,
          policyType: templateType,
          viewMethod,
          websiteUUID,
        })
      } catch (error) {
        console.warn('Failed to post translated policy event: %o', error)
      }
    })
  }
}
